import { Button, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { darkBlue2, white } from '@styles/colors'
import { FC, useState } from 'react';
import ChangeEmployerWotcStatus from './ChangeEmployerWotcStatus';
import MessageIcon from '@mui/icons-material/Message';
import RockerboxMessagingModal from './RockerboxMessagingModal';

type SingleEmployerActionProps = {
    employerData: any
};


const SingleEmployerAction: FC<SingleEmployerActionProps> = ({ employerData }) => {
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false)
    const [showMessageModal, setShowMessageModal] = useState(false)

    return (
        <>
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center" p={3} spacing={3} borderRadius='8px' bgcolor={white} >
                <Typography variant="h3" fontSize="28px" fontWeight="bold">
                    {employerData?.company.s_name || '-'}
                </Typography>
                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={3}>
                    <Button
                        startIcon={<MessageIcon />}
                        onClick={() => setShowMessageModal(true)}
                        variant="contained" color="primary" sx={{ fontSize: "16px" }} >
                        Messenger
                    </Button>
                    <ToggleButtonGroup
                        value={employerData.company.wotc_enabled}
                        exclusive
                        onChange={(event, newValue) => {
                            setShowStatusChangeModal(true)
                        }}
                    >
                        <ToggleButton
                            disabled={employerData.company.wotc_enabled}
                            sx={{
                                padding: "3px 15px",
                                borderBottomLeftRadius: '5px',
                                borderTopLeftRadius: '5px',
                                backgroundColor: employerData.company.wotc_enabled ? darkBlue2 : 'default',
                                color: employerData.company.wotc_enabled ? 'white' : 'default',
                                '&.Mui-selected': {
                                    backgroundColor: darkBlue2,
                                    color: 'white',
                                }
                            }} value={true}>On</ToggleButton>
                        <ToggleButton sx={{
                            padding: "3px 15px",
                            borderBottomRightRadius: '5px',
                            borderTopRightRadius: '5px',
                            backgroundColor: !employerData.company.wotc_enabled ? darkBlue2 : 'default',
                            color: !employerData.company.wotc_enabled ? 'white' : 'default',
                            '&.Mui-selected': {
                                backgroundColor: darkBlue2,
                                color: 'white',
                            }
                        }}
                            disabled={!employerData.company.wotc_enabled}
                            value={false}>Off</ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            </Stack >

            {showStatusChangeModal && (
                <ChangeEmployerWotcStatus
                    item={employerData}
                    handleClose={() => setShowStatusChangeModal(false)}

                />
            )
            }
            {showMessageModal && (
                <RockerboxMessagingModal
                    application={employerData}
                    isOpen={showMessageModal}
                    handleClose={() => setShowMessageModal(false)}
                />
            )
            }

        </>
    )
}

export default SingleEmployerAction